import {
    useContext,
    useMemo,
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type IPreferenceMenuItemProps from "./type";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getAppearStyle,
    usePresence
} from "../../../motion";
import {
    DropdownMenuRadioContext
} from "../../../../components/dropdownMenu/context";
import DropdownMenuMark from "../../../../components/dropdownMenu/components/mark";
import DropdownMenuRow from "../../../../components/dropdownMenu/components/row";

const PreferenceMenuItem: FC<IPreferenceMenuItemProps> = ({
    customTheme,
    option
}) => {
    const radioContext = useContext(DropdownMenuRadioContext);

    const {
        iconSizes,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const OptionIcon = option.icon;

    const isChecked = radioContext?.value === option.key;

    const {
        isReduceMotionEnabled,
        isRendered,
        progress
    } = usePresence({
        enterIntent: "iconAppear",
        exitIntent: "iconAppear",
        isVisible: isChecked,
        customTheme
    });

    const markStyle = useMemo(() => getAppearStyle({
        isReduceMotionEnabled,
        progress
    }), [
        isReduceMotionEnabled,
        progress
    ]);

    const handlePress = () => {
        radioContext?.onChange?.(option.key);
    };

    return <DropdownMenuRow
        leading={<OptionIcon
            customColor={colors.content.icon.mid}
            size={iconSizes.small}
            color="mid"
        />}
        trailing={<Animated.View
            style={markStyle}
        >
            <DropdownMenuMark
                customTheme={customTheme}
                isChecked={isRendered}
                kind="check"
            />
        </Animated.View>}
        customTheme={customTheme}
        ariaChecked={isChecked}
        isCloseOnSelect={true}
        onPress={handlePress}
        role="menuitemradio"
        title={option.title}
    />;
};
export default PreferenceMenuItem;
